import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button } from "antd";
import {
  MenuOutlined,
  HomeOutlined,
  FileTextOutlined,
  TeamOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import Footer from "../../../components/footer/Footer";
import { AuthContext } from "../../../context/AuthContext";
import ViewAnnouncement from "../../../components/employee/ViewAnnouncement"
import ViewMrfPage from "../viewmrfpage/ViewMrfPage";
import InterviewAssessment from "../interview/InterviewAssessment";
import AddVenue from "../AddVenue";

const { Sider, Content } = Layout;
const { Title } = Typography;

export default function OnboardHr() {
  const { authData } = useContext(AuthContext);

  // 🧭 State for selected menu and responsive UI
  const [selectedMenu, setSelectedMenu] = useState(
    () => localStorage.getItem("onboardHrPage") || "home"
  );
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    localStorage.setItem("onboardHrPage", selectedMenu);
  }, [selectedMenu]);

  // 🗂️ Menu items
  const menuItems = [
    { key: "home", icon: <HomeOutlined />, label: "Dashboard" },
    { key: "job_openings", icon: <FileTextOutlined />, label: "Job Openings" },
    { key: "interview", icon: <TeamOutlined />, label: "Interview & Assessment" },
    { key: "addVenue", icon: <EnvironmentOutlined />, label: "Add Venue" },
  ];

  // 📄 Page rendering
  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return (
          <>
            {/* <Title level={2}>
              Welcome {authData?.employee?.first_name || "Onboarding HR"}!
            </Title> */}
            <ViewAnnouncement />
          </>
        );
      case "job_openings":
        return <ViewMrfPage />;
      case "interview":
        return <InterviewAssessment />;
      case "addVenue":
        return <AddVenue />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />

      {/* 📱 Mobile Header with Drawer Trigger */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ background: "#fff" }}>
        {/* 🖥️ Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={280}
            collapsible
            collapsed={collapsed}
            onCollapse={(val) => setCollapsed(val)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
            }}
          >
            <style>
              {`
              .ant-menu {
                background: #fff !important;
                border-right: none !important;
              }

              .ant-menu-item,
              .ant-menu-submenu-title {
                font-weight: bold;
                color: #0e497b !important;
                transition: all 0.2s ease;
              }

              .ant-menu-item:hover,
              .ant-menu-submenu-title:hover {
                background-color: rgba(14, 73, 123, 0.05) !important;
                color: #0e497b !important;
              }

              .ant-menu-item-selected {
                background-color: #0e497b !important;
                color: #fff !important;
              }

              .ant-menu-item-selected .anticon {
                color: #fff !important;
              }

              .ant-menu-submenu-arrow::before,
              .ant-menu-submenu-arrow::after {
                background-color: #0e497b !important;
              }
            `}
            </style>

            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{
                height: "100%",
                borderRight: 0,
                background: "#fff",
                fontWeight: "bold",
              }}
              items={menuItems}
            />
          </Sider>
        )}

        {/* 📱 Mobile Drawer Sidebar */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          footer={null}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{
              height: "100%",
              borderRight: 0,
              background: "#fff",
              fontWeight: "bold",
            }}
            items={menuItems}
          />
        </Drawer>

        {/* 📄 Main Content */}
        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}
